import { useStyles } from "./FooterNavigationVodacom.style";
import { Typography } from "../../core/Typography/Typography";
import { TypographyColor } from "../../../constants/typography";
import { Icon } from "../../core/Icon/Icon";
import { FOOTER_NAVIGATION_VODACOM } from "../../../constants/footerNavigation";
import { useNavigate } from "react-router-dom";
import clsx from "classnames";
import { useTranslation } from "react-i18next";

const FooterNavigationVodacom: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      {FOOTER_NAVIGATION_VODACOM.map((item) => {
        return (
          <button
            key={item.id}
            className={clsx(classes.item)}
            data-testid={`${item?.id}-tab`}
            onClick={() => navigate(item?.path)}
          >
            {window.location.pathname === item?.path && (
              <div className={classes.active} />
            )}
            <Icon name={item.icon} className={classes.icon} />
            <Typography
              color={TypographyColor.Primary}
              className={classes.title}
              lines={1}
            >
              {t(item.title)}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};

export default FooterNavigationVodacom;
